import Button from "components/shared/button/Button";
import CircularProgress from "components/shared/circular-progress/CircularProgress";
import { useContext, useEffect, useState } from "react";
import GuiContext from "../../config/context/guiContext";
import PluginsContext from "../../config/context/pluginsContext";
import ToastContext from "../../config/context/toastContext";
import styles from "../../css/plugins.module.css";
import { pluginInstaller, pluginManager } from "../../lib/pluginManager";
import Loader from "../shared/loader/Loader";
import ToastList from "../toast/ToastList";
import EncryptionContext from "config/context/encryptionContext";

const PluginsOptional = ({ items, userPlugins, refreshData }) => {
  const {
    URL,
    userData: { guiname, id: accountId },
    selected: { selectedServer },
  } = useContext(GuiContext);
  const { updatePluginsContext } = useContext(PluginsContext);
  const [userPlgState, setUserPlgState] = useState(userPlugins);
  const [loadingStates, setLoadingStates] = useState({});
  const { insertIntoToastList, emptyToastList } = useContext(ToastContext);
  const { setEncryptionToDefault } = useContext(EncryptionContext);

  useEffect(() => {
    setUserPlgState(userPlugins);
  }, [userPlugins]);

  if (items === undefined || userPlgState === undefined) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  const renderedItems = items?.map((item, id) => {
    const userPlg = userPlgState?.find((obj) => obj.id === item.id);
    let isLoading = loadingStates[item.id] || false;

    const handleApplyPlugin = async () => {
      emptyToastList();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: true,
      }));
      let pluginSwitchRes = await pluginManager(
        true,
        item.id,
        URL,
        selectedServer,
        guiname,
        accountId,
        insertIntoToastList,
      );
      updatePluginsContext(pluginSwitchRes);
      await refreshData();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: false,
      }));
    };

    const handleDisablePlugin = async () => {
      emptyToastList();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: true,
      }));
      let pluginSwitchRes = await pluginManager(
        false,
        item.id,
        URL,
        selectedServer,
        guiname,
        accountId,
        insertIntoToastList,
      );
      updatePluginsContext(pluginSwitchRes);

      if (item?.id === 1) {
        setEncryptionToDefault();
      }

      await refreshData();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: false,
      }));
    };

    const handleInstallPlugin = async () => {
      emptyToastList();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: true,
      }));
      await pluginInstaller(
        item.id,
        URL,
        guiname,
        accountId,
        selectedServer,
        insertIntoToastList,
      );

      await refreshData();
      setLoadingStates((prevState) => ({
        ...prevState,
        [item.id]: false,
      }));
    };

    return (
      <div key={item.id} className={styles.tabItem}>
        <div>
          <h3>{item.plugin_name}</h3>
          <p>{item.plugin_desc}</p>
        </div>

        <div className={styles.buttonWrapper}>
          {isLoading ? (
            <CircularProgress />
          ) : userPlg ? (
            <>
              {!userPlg.active ? (
                <button className={styles.apply_btn} onClick={handleApplyPlugin}>
                  Apply
                </button>
              ) : (
                <button className={styles.disable_btn} onClick={handleDisablePlugin}>
                  Disable
                </button>
              )}
            </>
          ) : (
            <>
              <button className={styles.install_btn} onClick={handleInstallPlugin}>Install</button>
            </>
          )}
        </div>
        <ToastList />
      </div>
    );
  });

  return <div className={styles.tabWrapper}>{renderedItems}</div>;
};

export default PluginsOptional;
